/* Hover color change image product */
jQuery(document).ready(function($) {
  "use strict";
  $('.js-product-v1-slide').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: '<span class="engoc-slick-nav engoc-prev"><i class="fa fa-angle-left"></i></span>',
    nextArrow: '<span class="engoc-slick-nav engoc-next"><i class="fa fa-angle-right"></i></span>',
    dots: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.js-product-v2-slide').slick({
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  
  $('.js-testimonial-v1-slide').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.js-latest-post-v1-slide').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<button class="slideshow-arrow arrow-prev"><i class="fa fa-angle-left white fz-20"></i></button>',
    nextArrow: '<button class="slideshow-arrow arrow-next"><i class="fa fa-angle-right white fz-20"></i></button>',
    dots: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.js-slideshow-v1-slide').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<button class="slideshow-arrow arrow-prev"><i class="fa fa-angle-left white fz-20"></i></button>',
    nextArrow: '<button class="slideshow-arrow arrow-next"><i class="fa fa-angle-right white fz-20"></i></button>',
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: 'linear'
  });
  $('.js-slideshow-v1-slide').slickAnimation();

  $('.js-slideshow-v2-slide').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: '<button class="slideshow-arrow arrow-prev"><i class="fa fa-angle-left white fz-20"></i></button>',
    nextArrow: '<button class="slideshow-arrow arrow-next"><i class="fa fa-angle-right white fz-20"></i></button>',
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: 'linear'
  });
  $('.js-slideshow-v2-slide').slickAnimation();
  
  $('.js-collection-v2-slide').slick({
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button type="button" class="engoc-slick-arrow engoc-slick-prev"><i class="fa fa-angle-left fz-30 white"></i></button>',
    nextArrow: '<button type="button" class="engoc-slick-arrow engoc-slick-next"><i class="fa fa-angle-right fz-30 white"></i></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  /* AJAX SEARCH */
  var engoAutoComplate = {
    ajaxProductItems : function( input_element, result_wrapper, result_element ){
      var ajaxUrl  = '/search',
          result     = new Array(),
          keyword   = input_element.val();

      jQuery.ajax({
          type: 'GET',
          data: {
              q: "*" + keyword + "*",
              type: "product",
              view: "json",
          },
          dataType: "json",      
          url: ajaxUrl,
          beforeSend: function() {
            result_wrapper.show();
            result_element.html('<li class="loading"><p><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg> Loading...</p></li>');
          },
          complete:function(){
          },
          success: function ( reponse ) {
            var htmlbox = '';
            //result_element.html('');
            if( reponse.length > 0 ){
              for (var i = 0; i < reponse.length; i++) {

                var item              = reponse[i],
                    title            = item.title,
                    price            = item.price,
                    handle           = item.handle,
                    image            = item.featured_image,
                    compare_price    = item.compare_at_price  ? '<del>' + Shopify.formatMoney(item.compare_at_price, window.money_format) + '</del>' : "",
                    compare_class    = item.compare_at_price  ? "price-sale" : "price",
                    sold_out	       = item.available          ? "" : "<span class='item-sold-out'>Sold out</span> ",
                    price            = item.available          ? item.price : item.out_stock_nofication,
                    hightlight     = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="hightlight">$1</span>'),
                    template         = '<li class="result-item">'
                                        + '<a class="search-item-img" href="/products/'+ handle +'">'
                                        + '<img src="' + image + '" />' 
                                        +'</a>'
                                        +'<a class="search-item-title" href="/products/'+ handle +'">' + hightlight +'</a>'
                                        +'<span class="item-price '+ compare_class + '">'+ Shopify.formatMoney(price, window.money_format) + '</span>'
                                        + sold_out
                                        + compare_price
                                        +'</li>';
                htmlbox = htmlbox + template;


              }
              result_element.html(htmlbox);

              if($('.js_productSearchResults .search-results li').length){
                $('.js_productSearchResults').show();

              }
            }else{
              result_element.html('<li class="result-item"><p>No result found for your search.</p></li>');
               $('.js_productSearchResults').show();
            }
         }     
      });

    },

    ajaxSearch : function( options ){    
      var     ajax_timeout,
              ajax_lost_focus,
              self        = this,
              search_input_id    = options.search_input.length   > 0   ? options.search_input    : '.js_engo_autocomplate',
              wrapper_id         = options.result_wrapper.length > 0   ? options.result_wrapper  : '.js_productSearchResults',
              result_id          = options.result_element.length > 0   ? options.result_element  : '.search-results';

      jQuery( document ).delegate( search_input_id ,'keyup',function( event ){
        var keyword           = jQuery(this).val(),
            search_element    = jQuery(this),
            result_wrapper    = jQuery( wrapper_id ),
            result_element    = result_wrapper.children( result_id );

        if( ajax_timeout ){ 
          clearTimeout(ajax_timeout);
        } 

        ajax_timeout = setTimeout(function() {
          if( keyword.length >= 2 ){
              self.ajaxProductItems( search_element ,result_wrapper, result_element );
          }else{
              result_element.html("<li><p>You must enter at least 2 characters.</p></li>");
          } 
        },300);       
      }); 

    },

    init : function( options ){
      this.ajaxSearch( options );
    }
  }
 
  engoAutoComplate.init({
      "search_input"      :   ".js_engo_autocomplate",
      "result_wrapper"   :   ".js_productSearchResults",
      "result_element"   :   ".search-results"
  });
});
      
/* Promotion Countdown */
jQuery(document).ready(function($) {
  $.fn.ENGO_CountDown = function( options ) {
    return this.each(function() {
      // get instance of the ENGO_CountDown.
      new  $.ENGO_CountDown( this, options );
    });
  }
  $.ENGO_CountDown = function( obj, options ){
    var ddiff, gsecs;
    this.options = $.extend({
      autoStart           : true,
      LeadingZero:true,
      DisplayFormat:"<div><span>%%D%%</span> Days</div><div><span>%%H%%</span> Hours</div><div><span>%%M%%</span> Mins</div><div><span>%%S%%</span> Secs</div>",
      FinishMessage:"Expired",
      CountActive:true,
      TargetDate:null
    }, options || {} );
    if( this.options.TargetDate == null || this.options.TargetDate == '' ){
      return ;
    }
    this.timer  = null;
    this.element = obj;
    this.CountStepper = -1;
    this.CountStepper = Math.ceil(this.CountStepper);
    this.SetTimeOutPeriod = (Math.abs(this.CountStepper)-1)*1000 + 990;
    var dthen = new Date(this.options.TargetDate);
    var dnow = new Date();
    if( this.CountStepper > 0 ) {
      ddiff = new Date(dnow-dthen);
    }
    else {
      ddiff = new Date(dthen-dnow);
    }
    gsecs = Math.floor(ddiff.valueOf()/1000);
    this.CountBack(gsecs, this);
  };
  $.ENGO_CountDown.fn =  $.ENGO_CountDown.prototype;
  $.ENGO_CountDown.fn.extend =  $.ENGO_CountDown.extend = $.extend;
  $.ENGO_CountDown.fn.extend({
    calculateDate:function( secs, num1, num2 ){
      var s = ((Math.floor(secs/num1))%num2).toString();
      if ( this.options.LeadingZero && s.length < 2) {
        s = "0" + s;
      }
      return "<b>" + s + "</b>";
    },
    CountBack:function( secs, self ){
      var DisplayStr;
      if (secs < 0) {
        self.element.innerHTML = '<div class="labelexpired"> '+self.options.FinishMessage+"</div>";
        return;
      }
      clearInterval(self.timer);
      DisplayStr = self.options.DisplayFormat.replace(/%%D%%/g, self.calculateDate( secs,86400,100000) );
      DisplayStr = DisplayStr.replace(/%%H%%/g, self.calculateDate(secs,3600,24));
      DisplayStr = DisplayStr.replace(/%%M%%/g, self.calculateDate(secs,60,60));
      DisplayStr = DisplayStr.replace(/%%S%%/g, self.calculateDate(secs,1,60));
      self.element.innerHTML = DisplayStr;
      if (self.options.CountActive) {
        self.timer = null;
        self.timer =  setTimeout( function(){
          self.CountBack((secs+self.CountStepper),self);
        },( self.SetTimeOutPeriod ) );
      }
    }

  });

  function init_countdown() {
    /** Countdown **/
    $('[data-countdown="engoj_cta_countdown"]').each(function(index, el) {
      var $this = $(this);
      var $date = $this.data('date').split("-");
      $this.ENGO_CountDown({
        TargetDate:$date[0]+"/"+$date[1]+"/"+$date[2]+" "+$date[3]+":"+$date[4]+":"+$date[5],
        DisplayFormat:"<span class=\"days item\"><span class=\"number\">%%D%%</span><span class=\"text\">Days</span></span><span class=\"hour item\"><span class=\"number\">%%H%%</span><span class=\"text\">Hours</span></span><span class=\"mins item\"><span class=\"number\">%%M%%</span><span class=\"text\">Mins</span></span><span class=\"secs item\"><span class=\"number\">%%S%%</span><span class=\"text\">Secs</span></span>",
        FinishMessage: "Expired"
      });
    });
  }
  init_countdown();
});
      
$(window).on( "load", function() {
  $(".engoj-dynamic-checkout").find(".shopify-payment-button__button").addClass("btn-disabled");
});
$(document).on("change", ".engoj-agree", function() {
  var input_is_checked = $(".engoj-dynamic-checkout").find(".engoj-agree"), 
      btn_dynamic_checkout = $(".engoj-dynamic-checkout").find(".shopify-payment-button__button");
  input_is_checked.is(":checked") ? btn_dynamic_checkout.removeClass("btn-disabled") : btn_dynamic_checkout.addClass("btn-disabled");
});
  
  /* Hover color change image product */
  jQuery(document).ready(function($) {
    jQuery('.engoj_select_color a').each(function(){
      jQuery(this).on("mouseover",function(){
        var engoImage = jQuery(this).data('engojvariant-img');
        jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
        return false;
      });
    });
  });
      
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      
      $('.engoj-popup-video').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
      
      $('.engoj-popup-360').magnificPopup({
        type:'inline',
        midClick: true
      });